import * as React from 'react';
import ReactConfetti from 'react-confetti';
import { createPortal } from 'react-dom';

export function useConfetti() {
	const [isActive, setIsActive] = React.useState(false);
	const [key, setKey] = React.useState(0);
	const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);
	const popSound = React.useRef<HTMLAudioElement | null>(null);

	React.useEffect(() => {
		popSound.current = new Audio('/audio/applause.mp3');
		if (popSound.current) {
			popSound.current.volume = 0.5;
		}

		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	const triggerConfetti = React.useCallback(() => {
		setKey((prev) => prev + 1);
		setIsActive(true);

		// Play sound effect
		if (popSound.current) {
			popSound.current.currentTime = 0;
			popSound.current.play();
		}

		// Clear any existing timeout
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		// Set new timeout to stop confetti after 5 seconds
		timeoutRef.current = setTimeout(() => {
			setIsActive(false);
		}, 5000);
	}, []);

	const Confetti = React.useCallback(() => {
		if (!isActive) return null;

		return createPortal(
			<div
				className='fixed inset-0 pointer-events-none'
				style={{ zIndex: 2147483647 }}
			>
				<ReactConfetti
					key={key}
					width={window.innerWidth}
					height={window.innerHeight}
					recycle={false}
					numberOfPieces={500}
					gravity={0.3}
				/>
			</div>,
			document.body
		);
	}, [isActive, key]);

	return { triggerConfetti, Confetti };
}
